module.exports = __webpack_public_path__ + "img/logo.aa863a6a.png";